module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp2_5.33b85668.png";